import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import "./index.scss"
import WidgetFooterLink from "../widget-footer-link"

const WidgetFooter = () => {
  let links = []
  try {
    const result = useStaticQuery(graphql`
      {
        mdx(fileAbsolutePath: { regex: "/(widget-footer-body)/" }) {
          exports {
            WidgetFooterLinks {
              link
              to
            }
          }
        }
      }
    `)
    links = result.mdx.exports.WidgetFooterLinks
  } catch (error) {
    console.log("WidgetFooter", error)
  }
  return (
    <div id="WidgetFooter" className="WidgetFooter" data-testid="WidgetFooter">
      <hr />
      <ul className="widget-footer-links">
        {links?.map((item, index) => {
          return (
            <li key={index}>
              <WidgetFooterLink data={item.link} to={item.to} />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
export default WidgetFooter
